import { z } from "zod";
import { MetaSchema } from "./shared";
import AddressSchema from "./AddressSchema";

export const ReferralCodeLeaderSchema = z.object({
  id: z.string().uuid(),
  name: z.string(),
  status: z.string(),

  contractAddressDepositETH: AddressSchema,
  contractAddressWithdrawETH: AddressSchema,

  contractAddressDepositBSC: AddressSchema,
  contractAddressWithdrawBSC: AddressSchema,

  createdAt: z.string().datetime(),
  updatedAt: z.string().datetime(),
});

const ReferralCodesFindLeaderOfCodeResponse = z.object({
  data: ReferralCodeLeaderSchema,
  meta: MetaSchema.default,
});

export type ReferralCodesFindLeaderOfCodeResponseType = z.infer<
  typeof ReferralCodesFindLeaderOfCodeResponse
>;

export default ReferralCodesFindLeaderOfCodeResponse;
